module.exports = __webpack_public_path__ + "img/br.63fe0119.svg";